import { AppConfig } from '@app/app.config';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpService } from '@app/security/shared/http.service';
import { Injectable } from '@angular/core';
import { interval, Observable, Subject } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class VersionService {
  private readonly _versionUrl = '/assets/au_client_version.json';
  private _currentVersion?: string;
  private _started = false;
  private _versionChangedSubject = new Subject<void>();

  public get versionChanged$(): Observable<void> {
    return this._versionChangedSubject.asObservable();
  }

  constructor(
    private appConfig: AppConfig,
    private http: HttpClient,
    private auHttp: HttpService
  ) {}

  public start(): void {
    if (this._started) return;

    this.getVersion().subscribe({
      next: (data) => {
        console.log(`Version ${data?.version}`);
        this._currentVersion = data?.version;
      }
    });

    interval(this.appConfig.versionRefreshConfig.rate || 600_000)
      .pipe(
        switchMap(() => this.getVersion()),
        filter((v) => {
          console.log(this._currentVersion, v.version);
          return !!this._currentVersion && v.version !== this._currentVersion;
        })
      )
      .subscribe({
        next: (data) => {
          this._currentVersion = data.version;
          if (this.appConfig.versionRefreshConfig.forceRefresh) {
            window.location.reload();
          } else {
            this._versionChangedSubject.next();
          }
        }
      });

    this._started = true;
  }

  public getVersion(): Observable<IAppVersion> {
    const headers = new HttpHeaders({
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      Pragma: 'no-cache',
      Expires: '0'
    });

    // Query param defeats intermediary/browser caches
    const url = `${this._versionUrl}?t=${Date.now()}`;

    return this.http.get<IAppVersion>(url, { headers });
  }

  public sendRefreshCommand(): void {
    const endpoint = this.appConfig.getServerUri() + '/api/v1/users/force-refresh';
    this.auHttp.postAny(endpoint, undefined, undefined).subscribe({
      next: () => {
        alert('Force Refresh Event Sent');
      }
    });
  }
}

export interface IAppVersion {
  version: string;
}
